export const CHAT_START_TIMER = "CHAT_START_TIMER";
export const CHAT_RESET_TIMER = "CHAT_RESET_TIMER";
export const CHAT_STOP_TIMER = "CHAT_STOP_TIMER";
